import { Aluno } from './aluno';
import { Frequencia } from './frequencia';
import { Unidade } from './unidade';

export class FrequenciaAlunoUnidade extends Frequencia {
	aluno: Aluno;
	unidade: Unidade;
}